<template>
  <div class="swiper-fullscreen">
    <swiper :is-pagination="false" :height="'100%'" :loop="false" :autoplay="5000" ref="websiteSwiper">
      <swiper-item class="swiper-item">
        <div class="cover-wrapper" style="height:100%;background-image:url('/static/img/website-1.jpg')">
          <img src="/static/img/website-1.jpg">
        </div>
      </swiper-item>
      <swiper-item class="swiper-item">
        <div class="cover-wrapper" style="height:100%;background-image:url('/static/img/website-2.png')">
          <img src="/static/img/website-2.png">
        </div>
        <div class="container">
          <div class="page-caption">
            <h3 class="title">登录手机官网三种方法</h3>
            <div class="point"></div>
          </div>
          <div class="anim-wrapper">
            <div class="row">
              <div class="col-xs-4">
                <img class="methods-img" src="/static/img/website-3.jpg">
                <div class="methods-wrap">
                  <p class="methods">方法一</p>
                  <p><span class="iconfont">&#xe605;</span> 输入91weijia.com官网</p>
                </div>
              </div>
              <div class="col-xs-4">
                <img class="methods-img" src="/static/img/website-4.jpg">
                <div class="methods-wrap">
                  <p class="methods">方法二</p>
                  <p><span class="iconfont">&#xe604;</span> 扫一扫进入手机官网</p>
                </div>
              </div>
              <div class="col-xs-4">
                <img class="methods-img" src="/static/img/website-5.jpg">
                <div class="methods-wrap">
                  <p class="methods">方法三</p>
                  <p><span class="iconfont">&#xe606;</span> 微信公众号访问</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-item>
    </swiper>
  </div>
</template>

<script>
  import Swiper from '@/components/swiper/swiper'
  import SwiperItem from '@/components/swiper/swiper-item'

  export default {
    name: 'Website',
    components: {
      Swiper,
      SwiperItem
    },
    mounted () {
      this.$nextTick(() => {
        this.$refs.websiteSwiper.init()
      })
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .container
    position absolute
    top 0
    left 0
    right 0
  .page-caption
    margin-top 60px
    .title
      font-size 36px
      color #fff
    .point
      width 58px
  .row
    margin-top 0
    .col-xs-4
      text-align center
      .methods-wrap
        font-size 18px
        color #2b9efc
    .methods
      margin 10px auto 10px
      width 74px
      font-size 20px
      border 1px solid #2b9efc
      border-radius 2px
  .anim-wrapper
    width 80%
    margin 0 auto
  .methods-img
    max-width 70%
    box-shadow -1px 12px 16px 0 rgba(20,20,20,.7)
    transition all 0.35s
    -ms-transition all 0.35s
    transform scale(.9)
    -ms-transform scale(.9)
  .methods-img:hover
    transform scale(1)
    -ms-transform scale(1)
  @media (min-width: 1400px)
    .page-caption
      margin-top 100px
    .anim-wrapper
      width 100%
    .methods-img
      max-width 100%
    .row
      margin-top 50px
      .methods
        margin-top 50px
</style>



// WEBPACK FOOTER //
// website.vue?5c7ca91f